import certifications from "./certifications";

const inboxService = [{
    matcher: 'inbox/certification',
    reply: config => {
        return [200, certifications];
    }
},{
    matcher: /inbox\/certification\/(.*)/,
    reply: config => {
        const id = /inbox\/certification\/(.*)/.exec(config.url)[1];
        const data = certifications.find(certification => certification.id === id);
        return [200, data];
    }

}]

export default inboxService;